import { render, staticRenderFns } from "./ModalQuickProtocolFilter.vue?vue&type=template&id=d0d8f2ba&scoped=true"
import script from "./ModalQuickProtocolFilter.vue?vue&type=script&lang=js"
export * from "./ModalQuickProtocolFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d8f2ba",
  null
  
)

export default component.exports